module.exports = __webpack_public_path__ + "img/ysh.88de2e0e.png";